module.exports = "<button \r\n    class=\"btn btn-primary btn-lg btn-block nav-button\" \r\n    [class.selected]=\"selected\"\r\n    (click)=\"navigate()\">\r\n        {{title}}\r\n</button>"


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-nav-item/djiv-nav-item.component.html
// module id = ../../../../../src/app/shared/components/djiv-nav-item/djiv-nav-item.component.html
// module chunks = main